import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { buildUrlAndOpenSameWindow } from '../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../Config';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';

const Redirection = (props) => {

    useEffect(() => {

    }, []);

    return (
        <div className='redirection'>
            {
                props.iContent.title?.value &&
                <div className='title'> {props.iContent.title?.value} </div>
            }

            {
                props.iContent.subTitle?.value &&
                <div className='sub-title'> {props.iContent.subTitle?.value} </div>
            }

            {
                props.iContent.buttonText?.value &&
                <div className='button-wrapper'>
                    <BtnSubmit
                        isBusiness={false}
                        text={props.iContent.buttonText?.value}
                        onclick={handleOnClick}
                        formid='redirection-page'
                        isDisplayArrows={false}
                        isDisplayWhatsAppIcon={false}
                    />
                </div>
            }

        </div>
    );

    function handleOnClick() {
        buildUrlAndOpenSameWindow(props.iContent.link?.value);
    }

};

const mapStateToProps = (state) => {
    return {
        _authentication: state.authentication,
    };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Redirection);
